export const ACTION_TYPES = {
  CREAT_CONTACT_FORM: 'contact/CREAT_CONTACT_FORM',
  RESET: 'contact/RESET',
  CREAT_RESCIND_CONTACT_FORM: 'contact/CREAT_RESCIND_CONTACT_FORM',
};
